module.exports = __webpack_public_path__ + "img/tablet-elbow-5_68x54.c6d6c283.png";